import { Smartphone, MonitorSmartphone } from 'lucide-react';
import AppStoreButtons from './AppStoreButtons';
import AnimateIn from './AnimateIn';

const mobileHighlights = [
  { id: 'anytime', text: 'Use ActCheck on your phone, anytime' },
  { id: 'platforms', text: 'Available on both iOS and Android' },
  { id: 'download', text: 'Download the app to get started' },
];

function MobileHighlightList() {
  return (
    <div className="space-y-3 mb-8">
      {mobileHighlights.map((item) => (
        <div key={item.id} className="flex items-center gap-3">
          <Smartphone size={16} className="text-compliance-green flex-shrink-0" />
          <span className="text-white/80 font-body text-sm">{item.text}</span>
        </div>
      ))}
    </div>
  );
}

function MobileAppImage() {
  return (
    <AnimateIn direction="left">
      <div className="flex justify-center">
        <div className="relative">
          <div className="absolute inset-0 actcheck-gradient rounded-3xl blur-3xl opacity-15 scale-110" />
          <img
            src="/app-screenshot.png"
            alt="ActCheck mobile app screens showing welcome, rights guidance, and compliance features"
            data-testid="mobile-app-screenshot"
            className="relative w-full max-w-md rounded-2xl"
          />
        </div>
      </div>
    </AnimateIn>
  );
}

export default function MobileAppSection() {
  return (
    <section data-testid="mobile-app-section" className="relative py-20 sm:py-28 bg-navy overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-compliance-green/5 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full bg-deep-blue/50 blur-3xl" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <MobileAppImage />
          <div>
            <AnimateIn delay={100}>
              <div className="inline-flex items-center gap-2 bg-white/8 border border-white/10 rounded-full px-4 py-1.5 mb-6">
                <MonitorSmartphone size={14} className="text-soft-teal" />
                <span className="text-white/70 text-xs font-body font-medium">iOS & Android</span>
              </div>
            </AnimateIn>
            <AnimateIn delay={200}>
              <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white mb-5">
                Your compliance companion, wherever you are
              </h2>
            </AnimateIn>
            <AnimateIn delay={300}>
              <p className="text-white/65 font-body text-lg leading-relaxed mb-5">
                ActCheck is designed as a mobile-first experience. Download the app to access your compliance dashboard, document vault, reminders, and guidance library from your phone.
              </p>
            </AnimateIn>
            <AnimateIn delay={400}>
              <MobileHighlightList />
            </AnimateIn>
            <AnimateIn delay={500}>
              <AppStoreButtons variant="glass" />
            </AnimateIn>
          </div>
        </div>
      </div>
    </section>
  );
}
